<template>
    <div>
        <router-view :key="$route.fullPath"/>
        <CookieConsent />
    </div>
</template>

<script>
import CookieConsent from '@/components/common/CookieConsent.vue'
export default {
    name: 'App',
    components: {
        CookieConsent
    }
}
</script>